module.exports = __webpack_public_path__ + "static/media/ftm_logo_blue.3af63018.svg";